import React, { useEffect, useState } from "react";
import { Button, Collapse, Flex, notification, Skeleton } from "antd";
import DOMPurify from "dompurify";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import PostsApi from "../../api-services/posts-api.service";
import { Post } from "../../interfaces/post.interface";

const PRIMARY_COLOR = "#DC1A22";

// Custom SVG icons — gradient IDs prefixed with "bn_" to avoid DOM conflicts.

const IconDocument = () => (
  <svg width="17" height="20" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.8276 8.36625C18.8144 8.0775 18.7988 7.80375 18.7807 7.535C18.7535 7.13382 18.6587 6.74013 18.5001 6.37063C15.8888 2.96625 12.9457 0.58 12.6638 0.36125L12.6419 0.345C12.1351 0.0668748 11.5094 0.058125 11.5094 0.058125C11.3976 0.05125 11.2801 0.0443752 11.1544 0.0387502C11.0049 0.0312502 10.844 0.0247915 10.6719 0.0193748C10.3007 0.00749985 9.87132 0 9.36507 0H9.3082C6.48695 0.020625 6.2707 0.1675 4.92507 0.3575L4.89132 0.3625C3.79007 0.528125 2.73132 1.0975 1.90382 1.935C1.07632 2.7725 0.520696 3.84062 0.361321 4.94375L0.371321 4.95125C0.371022 4.95395 0.371022 4.95668 0.371321 4.95937C0.140071 6.58437 0.00382132 8.13813 7.13209e-05 10.6313C-0.00367868 13.1244 0.140696 14.6794 0.375071 16.3025C0.534446 17.4062 1.0907 18.4731 1.91695 19.3119C2.7432 20.1506 3.8032 20.7187 4.90445 20.8837L4.9382 20.8888C6.28382 21.08 6.7407 21.2344 9.5632 21.2463C12.3844 21.2262 12.6007 21.0794 13.9463 20.8888L13.9801 20.8837C15.0813 20.7187 16.1401 20.1494 16.9676 19.3119C17.7951 18.4744 18.3501 17.4062 18.5094 16.3025C18.7407 14.6775 18.8776 13.1244 18.8813 10.6313C18.8751 9.77875 18.8588 9.03812 18.8276 8.36625Z" fill="url(#bn_doc_g0)"/>
    <path d="M3.90875 14.7398C3.90677 14.6109 3.93086 14.483 3.97956 14.3636C4.02826 14.2443 4.10057 14.136 4.19216 14.0453C4.28374 13.9546 4.39271 13.8833 4.51252 13.8357C4.63233 13.7882 4.76051 13.7653 4.88937 13.7686C6.62187 13.7902 8.35458 13.7996 10.0875 13.7967C10.218 13.7963 10.3473 13.8217 10.468 13.8716C10.5886 13.9215 10.6981 13.9948 10.7902 14.0872C10.8824 14.1797 10.9552 14.2895 11.0046 14.4103C11.0541 14.5311 11.079 14.6605 11.0781 14.7911C11.077 15.0549 10.972 15.3078 10.786 15.4949C10.5999 15.6821 10.3476 15.7884 10.0837 15.7911C8.36125 15.7961 6.63854 15.7808 4.91562 15.7454C4.65108 15.7382 4.39935 15.63 4.21211 15.4429C4.02486 15.2559 3.91632 15.0043 3.90875 14.7398ZM3.875 10.5254C3.8778 10.2621 3.98439 10.0104 4.17162 9.82518C4.35886 9.63994 4.61161 9.53604 4.875 9.53605C7.9225 9.52314 10.97 9.52314 14.0175 9.53605C14.2799 9.53605 14.5316 9.64029 14.7171 9.82584C14.9026 10.0114 15.0069 10.263 15.0069 10.5254C15.0069 10.7878 14.9026 11.0395 14.7171 11.225C14.5316 11.4106 14.2799 11.5148 14.0175 11.5148C10.97 11.5256 7.92208 11.5256 4.87375 11.5148C4.61058 11.5145 4.35814 11.4104 4.17118 11.2252C3.98421 11.04 3.8778 10.7886 3.875 10.5254Z" fill="white"/>
    <path d="M18.5 6.37109C15.8888 2.96672 12.9456 0.580469 12.6637 0.361719L12.6419 0.345469C12.135 0.0673435 11.5094 0.0585938 11.5094 0.0585938H11.5V0.121094C11.5267 1.87109 11.5475 3.61964 11.5625 5.36672C11.5681 5.92966 11.7935 6.46813 12.1904 6.86731C12.5874 7.2665 13.1246 7.49482 13.6875 7.50359C15.3812 7.52401 17.075 7.5563 18.7687 7.60047H18.7825L18.7787 7.53797C18.7525 7.13605 18.6582 6.7415 18.5 6.37109Z" fill="url(#bn_doc_g1)"/>
    <defs>
      <linearGradient id="bn_doc_g0" x1="16.9244" y1="19.3475" x2="0.70632" y2="3.13" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EF3739"/><stop offset="0.54" stopColor="#EF3739"/><stop offset="1" stopColor="#FF8C8B"/>
      </linearGradient>
      <linearGradient id="bn_doc_g1" x1="23.6469" y1="14.7092" x2="12.3144" y2="3.37672" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EF3739"/><stop offset="0.54" stopColor="#EF3739"/><stop offset="1" stopColor="#FF8C8B"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconTravel = () => (
  <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.1169 20.8459C25.8544 20.6584 26.3575 20.3609 26.4869 19.564C26.6025 18.7615 26.6894 16.7515 26.57 15.2627C26.4506 13.774 26.3025 12.6802 26.0669 11.8777C25.665 10.5559 25.2081 9.38336 23.8619 9.12774C23.0437 8.96649 17.4531 8.76711 15.9631 8.78336C14.4731 8.76711 9.92374 8.92774 9.10749 9.08899C7.76374 9.34649 6.39562 10.5571 6.00749 11.879C5.69604 12.984 5.5004 14.1185 5.42374 15.264C5.31999 16.7534 5.37499 18.6252 5.54124 19.4171C5.70749 20.209 6.19124 20.6184 6.90499 20.8202C8.73777 21.3138 10.6172 21.6142 12.5125 21.7165C13.7625 21.7615 16.1512 21.7884 16.8006 21.779C17.4381 21.7859 18.4519 21.7596 19.5069 21.7165C22.4 21.5727 25.1169 20.8459 25.1169 20.8459Z" fill="url(#bn_travel_g0)"/>
    <path d="M11.1648 15.1513C11.1649 15.2109 11.1531 15.27 11.1302 15.325C11.1072 15.38 11.0736 15.43 11.0312 15.4719C10.9888 15.5138 10.9385 15.5469 10.8832 15.5692C10.8279 15.5915 10.7688 15.6027 10.7091 15.6019C10.3191 15.5975 9.15914 15.5932 8.77164 15.5875C8.30102 15.5807 7.77602 15.2125 7.76727 14.8169C7.71039 14.0669 7.86727 13.32 8.21289 12.5669C8.37164 12.2607 8.78227 12.0338 9.14539 12.0288C9.41039 12.025 10.446 12.0219 10.7079 12.0188C10.7675 12.0182 10.8267 12.0295 10.8819 12.0519C10.9372 12.0743 10.9874 12.1074 11.0298 12.1494C11.0722 12.1914 11.1058 12.2413 11.1288 12.2963C11.1517 12.3514 11.1635 12.4104 11.1635 12.47L11.1648 15.1513ZM15.8523 15.1869C15.8523 15.2463 15.8405 15.3052 15.8177 15.36C15.7949 15.4149 15.7615 15.4647 15.7194 15.5067C15.6773 15.5486 15.6274 15.5818 15.5724 15.6044C15.5174 15.6269 15.4586 15.6384 15.3991 15.6382C14.6591 15.6344 13.5335 15.6288 12.7935 15.6225C12.6745 15.6215 12.5608 15.5736 12.4771 15.489C12.3934 15.4045 12.3465 15.2903 12.3466 15.1713V12.4513C12.3466 12.3324 12.3936 12.2182 12.4773 12.1337C12.5609 12.0492 12.6746 12.0012 12.7935 12C13.5335 11.9938 14.6591 11.9888 15.3991 11.985C15.4586 11.9848 15.5174 11.9963 15.5724 12.0188C15.6274 12.0414 15.6773 12.0746 15.7194 12.1165C15.7615 12.1585 15.7949 12.2083 15.8177 12.2632C15.8405 12.318 15.8523 12.3769 15.8523 12.4363V15.1869ZM20.4648 15.195C20.4648 15.3145 20.4174 15.4291 20.333 15.5137C20.2487 15.5983 20.1342 15.646 20.0148 15.6463C19.2748 15.6463 18.1491 15.6463 17.4091 15.6463C17.2897 15.646 17.1752 15.5983 17.0909 15.5137C17.0065 15.4291 16.9591 15.3145 16.9591 15.195V12.4288C16.9591 12.3093 17.0065 12.1947 17.0909 12.1101C17.1752 12.0256 17.2897 11.9779 17.4091 11.9775H20.0148C20.1342 11.9779 20.2487 12.0256 20.333 12.1101C20.4174 12.1947 20.4648 12.3093 20.4648 12.4288V15.195ZM25.4373 16.535C25.3749 16.5783 25.3032 16.6065 25.2281 16.6173C25.1529 16.6282 25.0762 16.6214 25.0041 16.5975L21.9229 15.6025C21.8404 15.5773 21.7671 15.5283 21.7124 15.4615C21.6577 15.3948 21.624 15.3134 21.6154 15.2275C21.6154 15.2169 21.6154 15.2057 21.6154 15.1944V12.4338C21.6155 12.3745 21.6272 12.3158 21.65 12.261C21.6728 12.2062 21.7062 12.1565 21.7482 12.1147C21.7903 12.0728 21.8401 12.0397 21.895 12.0171C21.9498 11.9945 22.0086 11.983 22.0679 11.9832C22.761 11.9863 23.6085 11.99 24.3016 11.9957C24.6541 11.9957 24.9698 12.1907 25.0741 12.4763V12.4813C25.4491 13.8113 25.5498 14.9082 25.6141 16.1782C25.6187 16.248 25.6048 16.3177 25.5737 16.3804C25.5427 16.4431 25.4956 16.4964 25.4373 16.535Z" fill="url(#bn_travel_g1)"/>
    <path d="M24.4108 13.5612L24.3934 13.5632C24.1381 13.5925 23.9549 13.8231 23.9842 14.0784L24.1427 15.4607C24.172 15.716 24.4026 15.8992 24.6579 15.8699L24.6753 15.8679C24.9306 15.8386 25.1138 15.608 25.0845 15.3527L24.926 13.9704C24.8967 13.7151 24.666 13.5319 24.4108 13.5612Z" fill="url(#bn_travel_g2)"/>
    <path d="M9.73172 23.2193C11.0959 23.2193 12.2017 22.1134 12.2017 20.7493C12.2017 19.3852 11.0959 18.2793 9.73172 18.2793C8.36758 18.2793 7.26172 19.3852 7.26172 20.7493C7.26172 22.1134 8.36758 23.2193 9.73172 23.2193Z" fill="url(#bn_travel_g3)"/>
    <path d="M22.2869 23.2193C23.651 23.2193 24.7569 22.1134 24.7569 20.7493C24.7569 19.3852 23.651 18.2793 22.2869 18.2793C20.9228 18.2793 19.8169 19.3852 19.8169 20.7493C19.8169 22.1134 20.9228 23.2193 22.2869 23.2193Z" fill="url(#bn_travel_g4)"/>
    <defs>
      <linearGradient id="bn_travel_g0" x1="23.4744" y1="22.9946" x2="8.87624" y2="8.39711" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE7838"/><stop offset="0.54" stopColor="#FE7636"/><stop offset="1" stopColor="#FFAD8A"/>
      </linearGradient>
      <linearGradient id="bn_travel_g1" x1="22.3416" y1="19.6375" x2="11.716" y2="9.01254" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFDDCE"/><stop offset="0.57" stopColor="white"/><stop offset="1" stopColor="white"/>
      </linearGradient>
      <linearGradient id="bn_travel_g2" x1="25.2632" y1="15.4455" x2="23.8267" y2="14.009" gradientUnits="userSpaceOnUse">
        <stop stopColor="#34344F"/><stop offset="0.54" stopColor="#353551"/><stop offset="1" stopColor="#666684"/>
      </linearGradient>
      <linearGradient id="bn_travel_g3" x1="10.6777" y1="20.9753" x2="7.60432" y2="17.1056" gradientUnits="userSpaceOnUse">
        <stop stopColor="#34344F"/><stop offset="0.54" stopColor="#353551"/><stop offset="1" stopColor="#666684"/>
      </linearGradient>
      <linearGradient id="bn_travel_g4" x1="23.1582" y1="22.4067" x2="20.0842" y2="18.5369" gradientUnits="userSpaceOnUse">
        <stop stopColor="#34344F"/><stop offset="0.54" stopColor="#353551"/><stop offset="1" stopColor="#666684"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconFolder = () => (
  <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4339 6.13158C18.8037 5.66266 18.0448 5.39847 17.2596 5.37471C14.9725 5.31944 12.6843 5.4136 10.4096 5.65658C8.8902 5.83283 7.43332 7.28971 7.25707 8.80971C6.85832 12.5372 6.85832 19.4597 7.25707 23.1878C7.43332 24.7072 8.8902 26.1641 10.4096 26.3403C14.1281 26.7393 17.8786 26.7393 21.5971 26.3403C23.1164 26.1641 24.5733 24.7072 24.7496 23.1878C25.0214 20.6485 25.1077 16.6253 25.0089 13.1435V13.1291C25.0022 12.3785 24.7585 11.6492 24.3127 11.0453C22.9385 9.17503 21.2944 7.51906 19.4339 6.13158Z" fill="url(#bn_folder_g0)"/>
    <path d="M25.0048 13.145C24.7155 13.1525 24.4255 13.1569 24.138 13.1569C22.9141 13.1566 21.6911 13.0913 20.4742 12.9613H20.4636C19.7386 12.8769 19.0261 12.5169 18.4567 11.9481C17.8873 11.3794 17.5273 10.6656 17.4436 9.9375C17.4432 9.93397 17.4432 9.93041 17.4436 9.92688C17.282 8.41529 17.2202 6.89471 17.2586 5.375C18.0436 5.3984 18.8026 5.66214 19.433 6.13062C21.2968 7.5215 22.9436 9.18173 24.3192 11.0569C24.7628 11.6576 25.0036 12.3839 25.0067 13.1306L25.0048 13.145Z" fill="url(#bn_folder_g1)"/>
    <path d="M16.5398 22.1123C16.5236 22.1881 16.4858 22.2576 16.4311 22.3124C16.3763 22.3672 16.3068 22.4049 16.231 22.4211C15.9798 22.4603 15.7241 22.4603 15.4729 22.4211C15.3971 22.4049 15.3276 22.3672 15.2728 22.3124C15.218 22.2576 15.1803 22.1881 15.1641 22.1123C15.1258 21.8611 15.1258 21.6055 15.1641 21.3542C15.1803 21.2784 15.218 21.209 15.2728 21.1542C15.3276 21.0994 15.3971 21.0616 15.4729 21.0455C15.7241 21.0063 15.9798 21.0063 16.231 21.0455C16.3068 21.0616 16.3763 21.0994 16.4311 21.1542C16.4858 21.209 16.5236 21.2784 16.5398 21.3542C16.5789 21.6054 16.5789 21.8612 16.5398 22.1123ZM17.2498 18.5773C16.5854 18.9873 16.4191 19.198 16.4191 19.608V19.733C16.4191 19.8174 16.4025 19.9011 16.3701 19.9791C16.3377 20.0572 16.2903 20.128 16.2305 20.1877C16.1707 20.2474 16.0997 20.2947 16.0216 20.3269C15.9435 20.3591 15.8599 20.3756 15.7754 20.3755C15.605 20.3755 15.4416 20.3078 15.3211 20.1873C15.2006 20.0668 15.1329 19.9034 15.1329 19.733V19.4405C15.1329 18.7648 15.4541 18.3105 16.2185 17.8561C16.9716 17.413 17.2154 17.1136 17.2154 16.6598C17.2154 16.128 16.7723 15.7848 16.1185 15.7848C15.4129 15.7848 14.9598 16.1223 14.7654 16.7355C14.7173 16.8838 14.6207 17.0116 14.4911 17.0984C14.3615 17.1851 14.2065 17.2257 14.051 17.2136C13.9462 17.2058 13.8445 17.1744 13.7535 17.1218C13.6626 17.0692 13.5846 16.9967 13.5256 16.9097C13.4666 16.8227 13.428 16.7236 13.4127 16.6196C13.3974 16.5156 13.4058 16.4095 13.4373 16.3092C13.7891 15.2117 14.7716 14.5117 16.1216 14.5117C17.5066 14.5117 18.6035 15.4086 18.6035 16.6367C18.6004 17.4473 18.1904 18.0005 17.2498 18.5773Z" fill="url(#bn_folder_g2)"/>
    <defs>
      <linearGradient id="bn_folder_g0" x1="23.6483" y1="25.2941" x2="6.70645" y2="8.35283" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EF3739"/><stop offset="0.54" stopColor="#EF3739"/><stop offset="1" stopColor="#FF8C8B"/>
      </linearGradient>
      <linearGradient id="bn_folder_g1" x1="24.1142" y1="14.0362" x2="16.3567" y2="6.27813" gradientUnits="userSpaceOnUse">
        <stop stopColor="#34344F"/><stop offset="0.26" stopColor="#3B3B57"/><stop offset="0.66" stopColor="#50506D"/><stop offset="1" stopColor="#666684"/>
      </linearGradient>
      <linearGradient id="bn_folder_g2" x1="18.306" y1="20.438" x2="13.6035" y2="15.7355" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFD2D2"/><stop offset="0.57" stopColor="white"/><stop offset="1" stopColor="white"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconShield = () => (
  <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.0739 14.1929C25.0426 12.4156 24.883 10.6429 24.5964 8.88856C24.4115 8.53188 24.1035 8.25433 23.7296 8.10731C21.2389 7.14106 18.7889 6.21919 16.4008 5.43231C16.1588 5.35199 15.8972 5.35199 15.6552 5.43231C13.2677 6.21731 10.8177 7.13731 8.32706 8.10294C7.99685 8.23242 7.71688 8.46441 7.52831 8.76481C7.54206 8.76481 7.01643 10.4092 6.92643 14.0354C6.87518 17.6623 7.32518 18.7504 7.31268 18.7504C7.55706 19.5479 8.01456 20.3586 8.67018 21.1836C9.40331 22.1042 10.3939 23.0554 11.5896 23.9911C13.5696 25.5448 15.4227 26.4742 15.5002 26.5067C15.6653 26.5887 15.8471 26.6313 16.0314 26.6313C16.2158 26.6313 16.3976 26.5887 16.5627 26.5067C16.6408 26.4736 18.4958 25.5417 20.4752 23.9886C21.6714 23.0511 22.6627 22.1017 23.3952 21.1804C24.0977 20.2979 24.5727 19.4304 24.8021 18.5798C24.7883 18.5773 25.1202 17.2454 25.0739 14.1929Z" fill="url(#bn_shield_g0)"/>
    <path d="M17.0132 16.5732V18.507C17.0132 18.7685 16.9093 19.0194 16.7244 19.2044C16.5394 19.3893 16.2885 19.4932 16.027 19.4932C15.7654 19.4932 15.5145 19.3893 15.3296 19.2044C15.1446 19.0194 15.0407 18.7685 15.0407 18.507V16.6007C14.6067 16.3855 14.2577 16.0305 14.0498 15.5929C13.8419 15.1554 13.7872 14.6606 13.8944 14.1881C14.0017 13.7157 14.2647 13.2931 14.6411 12.9882C15.0176 12.6833 15.4857 12.5138 15.9701 12.507C16.4545 12.5003 16.9271 12.6566 17.3119 12.9509C17.6968 13.2452 17.9715 13.6604 18.0918 14.1296C18.2122 14.5989 18.1713 15.095 17.9757 15.5382C17.7801 15.9814 17.4411 16.3459 17.0132 16.5732Z" fill="url(#bn_shield_g1)"/>
    <defs>
      <linearGradient id="bn_shield_g0" x1="23.1396" y1="21.5467" x2="7.66706" y2="6.07419" gradientUnits="userSpaceOnUse">
        <stop stopColor="#13B601"/><stop offset="0.57" stopColor="#13B601"/><stop offset="1" stopColor="#CBF4B4"/>
      </linearGradient>
      <linearGradient id="bn_shield_g1" x1="18.0926" y1="17.8363" x2="13.9351" y2="13.6782" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CBF4B4"/><stop offset="0.57" stopColor="white"/><stop offset="1" stopColor="white"/>
      </linearGradient>
    </defs>
  </svg>
);

const IconLock = () => (
  <svg width="18" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.1325 6.6866C12.845 6.61473 11.2675 6.5791 9.7575 6.5791C8.2475 6.5791 6.67063 6.61473 5.3825 6.6866C5.3825 6.6866 4.6525 6.6966 3.43813 6.87785C2.58942 7.06894 1.82208 7.52156 1.24428 8.17191C0.66647 8.82226 0.307338 9.63755 0.2175 10.5029L0.214375 10.5322C0.095 11.6829 0 11.3741 0 13.8116C0 16.2491 0.0950002 16.1447 0.215 17.2997L0.218125 17.3285C0.316844 18.2776 0.738978 19.1638 1.4137 19.8385C2.08842 20.5132 2.97467 20.9354 3.92375 21.0341C5.31438 21.176 7.60625 21.2491 9.7575 21.2491C11.9087 21.2491 14.2006 21.1754 15.5912 21.031C16.5403 20.9323 17.4266 20.5101 18.1013 19.8354C18.776 19.1607 19.1982 18.2744 19.2969 17.3254L19.3 17.296C19.42 16.1416 19.515 16.2429 19.515 13.8085C19.515 11.3741 19.42 11.6835 19.3 10.5279L19.2969 10.4985C19.207 9.63318 18.8479 8.81789 18.2701 8.16753C17.6923 7.51718 16.925 7.06456 16.0763 6.87348C15.2356 6.7391 14.1325 6.6866 14.1325 6.6866Z" fill="url(#bn_lock_g0)"/>
    <path d="M16.0813 6.87437C16.0663 5.53875 16.0126 4.33125 15.9307 3.55C15.8403 2.68013 15.4535 1.86781 14.8353 1.24923C14.217 0.630657 13.4049 0.243437 12.5351 0.1525H12.5138C12.3926 0.14 12.2845 0.1275 12.1813 0.11625C11.6045 0.05375 11.1488 0 9.69135 0C8.30197 0 7.92697 0.0450001 7.4076 0.1075C7.28947 0.12125 7.16322 0.13625 7.0101 0.1525H6.99135C6.12119 0.243032 5.30865 0.630074 4.69003 1.24869C4.07142 1.8673 3.68438 2.67985 3.59385 3.55C3.5126 4.33125 3.45885 5.53875 3.44385 6.87437L5.3876 6.68313C5.4051 5.49875 5.45447 4.42562 5.52447 3.75125C5.56904 3.3237 5.75946 2.92454 6.0637 2.62086C6.36795 2.31719 6.76747 2.12752 7.1951 2.08375H7.21385C7.37697 2.06687 7.5126 2.05062 7.63947 2.035C8.10885 1.97875 8.41885 1.94187 9.6926 1.94187C11.0413 1.94187 11.4088 1.98312 11.9657 2.04562C12.0738 2.0575 12.187 2.07062 12.3126 2.08375H12.3338C12.7604 2.1285 13.1586 2.31835 13.4619 2.62154C13.7652 2.92473 13.9552 3.32288 14.0001 3.74937C14.0707 4.42375 14.1195 5.49938 14.137 6.68125L16.0813 6.87437Z" fill="url(#bn_lock_g1)"/>
    <path d="M10.7701 14.6687V16.6019C10.7636 16.859 10.6569 17.1035 10.4727 17.2831C10.2885 17.4627 10.0414 17.5633 9.78416 17.5633C9.52689 17.5633 9.27981 17.4627 9.09561 17.2831C8.91142 17.1035 8.8047 16.859 8.79823 16.6019V14.6962C8.36434 14.481 8.01542 14.1262 7.80756 13.6887C7.5997 13.2513 7.54498 12.7567 7.6522 12.2844C7.75942 11.8121 8.02235 11.3895 8.39871 11.0847C8.77507 10.7799 9.24301 10.6105 9.72728 10.6037C10.2116 10.597 10.684 10.7533 11.0687 11.0475C11.4535 11.3417 11.7281 11.7567 11.8484 12.2258C11.9688 12.695 11.9279 13.1909 11.7323 13.634C11.5367 14.0771 11.1978 14.4415 10.7701 14.6687Z" fill="url(#bn_lock_g2)"/>
    <defs>
      <linearGradient id="bn_lock_g0" x1="16.8912" y1="21.046" x2="2.62375" y2="6.7791" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FE7838"/><stop offset="0.54" stopColor="#FE7636"/><stop offset="1" stopColor="#FFAD8A"/>
      </linearGradient>
      <linearGradient id="bn_lock_g1" x1="14.0163" y1="8.93937" x2="5.50822" y2="0.43125" gradientUnits="userSpaceOnUse">
        <stop stopColor="#34344F"/><stop offset="0.54" stopColor="#353551"/><stop offset="1" stopColor="#666684"/>
      </linearGradient>
      <linearGradient id="bn_lock_g2" x1="11.8495" y1="15.9312" x2="7.6926" y2="11.7744" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFDDCE"/><stop offset="0.57" stopColor="white"/><stop offset="1" stopColor="white"/>
      </linearGradient>
    </defs>
  </svg>
);

interface GroupConfig {
  name: string;
  icon: React.ReactNode;
  iconBg: string;
  keywords: string[]; // case-insensitive substring match against section title
}

export const BOOKING_NOTICE_GROUPS: GroupConfig[] = [
  {
    name: "Before You Book",
    icon: <IconDocument />,
    iconBg: "#FFE5E5",
    keywords: ["travel document", "tour pricing", "special request", "accommodation", "child policy"],
  },
  {
    name: "Group and Tour Requirements",
    icon: <IconTravel />,
    iconBg: "#FFF1EB",
    keywords: ["group package", "minimum group", "changes to itinerary", "flight schedule"],
  },
  {
    name: "Changes and Cancellations",
    icon: <IconFolder />,
    iconBg: "#FFE5E5",
    keywords: ["cancellation charge", "tour cancellation", "unused service"],
  },
  {
    name: "Safety and Responsibilities",
    icon: <IconShield />,
    iconBg: "#E5F4D9",
    keywords: ["liability", "responsibility", "waiver"],
  },
  {
    name: "Privacy and Legal",
    icon: <IconLock />,
    iconBg: "#FFF1EB",
    keywords: ["personal data", "amendment"],
  },
];

function matchGroup(title: string): GroupConfig | null {
  const lower = title.toLowerCase();
  return BOOKING_NOTICE_GROUPS.find((g) =>
    g.keywords.some((kw) => lower.includes(kw))
  ) ?? null;
}

const ChevronDownIcon: React.FC<{ isActive?: boolean }> = ({ isActive }) => (
  <svg
    width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
    style={{ transform: isActive ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", flexShrink: 0 }}
  >
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function buildCollapseItems(
  sections: Post[],
  openPanels: string[],
) {
  return sections.map((section) => {
    const isActive = openPanels.includes(String(section.id));
    return {
      key: String(section.id),
      label: (
        <span style={{ fontWeight: 400, color: isActive ? PRIMARY_COLOR : "inherit" }}>
          {section.title}
        </span>
      ),
      style: {
        marginBottom: 8,
        borderRadius: 8,
        border: "1px solid #f0f0f0",
        borderLeft: isActive ? `4px solid ${PRIMARY_COLOR}` : "1px solid #f0f0f0",
        background: "#fff",
        overflow: "hidden",
        transition: "border-left 0.2s ease",
      },
      children: (
        <div style={{ borderTop: "1px solid #f5f5f5", paddingTop: 8 }}>
          <Markdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
              a: ({ href, target, children: linkChildren, ...props }) => (
                <a
                  href={href}
                  target={target}
                  rel={target === "_blank" ? "noopener noreferrer" : undefined}
                  {...props}
                >
                  {linkChildren}
                </a>
              ),
            }}
          >
            {DOMPurify.sanitize(section.content, { ADD_ATTR: ["target"] })}
          </Markdown>
        </div>
      ),
    };
  });
}

const GroupedView: React.FC<{
  sections: Post[];
  openPanels: string[];
  setOpenPanels: (keys: string[]) => void;
}> = ({ sections, openPanels, setOpenPanels }) => {
  const grouped = BOOKING_NOTICE_GROUPS.map((config) => ({
    config,
    items: sections.filter((s) => matchGroup(s.title) === config),
  })).filter((g) => g.items.length > 0);

  const ungrouped = sections.filter((s) => !matchGroup(s.title));

  const handleChange = (keys: string | string[]) =>
    setOpenPanels(Array.isArray(keys) ? keys : [keys]);

  return (
    <Flex vertical gap={24}>
      {grouped.map(({ config, items }) => (
        <div key={config.name} className="bn-group">
          <div className="bn-group_header">
            <span className="bn-group_icon" style={{ background: config.iconBg }}>
              {config.icon}
            </span>
            <span className="bn-group_name">{config.name}</span>
          </div>
          <Collapse
            activeKey={openPanels}
            onChange={handleChange}
            bordered={false}
            expandIconPosition="end"
            expandIcon={({ isActive }) => <ChevronDownIcon isActive={isActive} />}
            style={{ background: "transparent" }}
            items={buildCollapseItems(items, openPanels)}
          />
        </div>
      ))}

      {ungrouped.length > 0 && (
        <Collapse
          activeKey={openPanels}
          onChange={handleChange}
          bordered={false}
          expandIconPosition="end"
          expandIcon={({ isActive }) => <ChevronDownIcon isActive={isActive} />}
          style={{ background: "transparent" }}
          items={buildCollapseItems(ungrouped, openPanels)}
        />
      )}
    </Flex>
  );
};

const BookingNoticeTab: React.FC<{ removeHeader?: boolean; grouped?: boolean }> = ({
  removeHeader = false,
  grouped = false,
}) => {
  const [sections, setSections] = useState<Post[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [openPanels, setOpenPanels] = useState<string[]>([]);

  useEffect(() => {
    const postsApi = new PostsApi();
    postsApi
      .getPosts("booking_notice", 1, { limit: 50 })
      .then(({ posts }) => {
        setSections(posts);
      })
      .catch(() => {
        notification.error({ message: "An error occurred while loading Booking Notice." });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const allKeys = sections.map((s) => String(s.id));
  const allExpanded = openPanels.length === sections.length && sections.length > 0;

  const toggleShowAll = () => {
    setOpenPanels(allExpanded ? [] : allKeys);
  };

  if (loading) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  if (sections.length === 0) {
    return null;
  }

  const handleChange = (keys: string | string[]) =>
    setOpenPanels(Array.isArray(keys) ? keys : [keys]);

  return (
    <div className="booking-notice-tab">
      <Flex vertical gap={16}>
        {!removeHeader && (
          <>
            <Flex justify="space-between" align="center" className="booking-notice-tab__header">
              <h2 style={{ margin: 0 }}>Notice</h2>
              <Button type="link" onClick={toggleShowAll} style={{ color: PRIMARY_COLOR }}>
                {allExpanded ? "Collapse All" : "Expand All"}
              </Button>
            </Flex>
            <div>
              <span>Please review the following important information before confirming your booking to ensure a smooth and enjoyable travel experience.</span>
            </div>
          </>
        )}

        {grouped ? (
          <GroupedView
            sections={sections}
            openPanels={openPanels}
            setOpenPanels={setOpenPanels}
          />
        ) : (
          <Collapse
            activeKey={openPanels}
            onChange={handleChange}
            bordered={false}
            expandIconPosition="end"
            expandIcon={({ isActive }) => <ChevronDownIcon isActive={isActive} />}
            style={{ background: "transparent" }}
            items={buildCollapseItems(sections, openPanels)}
          />
        )}
      </Flex>
    </div>
  );
};

export default BookingNoticeTab;
